import { createContext, useContext } from 'react'

export interface CatalogComponentRuntimeContextValue {
  pageFilterSelectionsOverride?: Record<string, unknown>[]
  allowRouteNavigation?: boolean
}

const CatalogComponentRuntimeContext = createContext<CatalogComponentRuntimeContextValue>({
  allowRouteNavigation: true,
})

export function CatalogComponentRuntimeProvider({
  children,
  value,
}: {
  children: React.ReactNode
  value: CatalogComponentRuntimeContextValue
}) {
  return <CatalogComponentRuntimeContext.Provider value={value}>{children}</CatalogComponentRuntimeContext.Provider>
}

export function useCatalogComponentRuntime() {
  return useContext(CatalogComponentRuntimeContext)
}
